import Modal from 'react-modal'
import { Icon } from '../../Elements'
import React from 'react'

const RaytebModal = ({
  isOpen,
  appElement,
  aria,
  bodyOpenClassName,
  children,
  className,
  closeTimeoutMS,
  contentElement,
  contentLabel,
  contentRef,
  data,
  htmlOpenClassName,
  id,
  onAfterClose,
  onAfterOpen,
  onRequestClose,
  overlayClassName,
  overlayElement,
  overlayRef,
  parentSelector,
  portalClassName,
  preventScroll,
  role,
  shouldCloseOnEsc,
  shouldCloseOnOverlayClick,
  shouldFocusAfterRender,
  shouldReturnFocusAfterClose,
  style,
  testId,
  title,
  hideModal,
}: RaytebModalInterface) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        appElement={appElement}
        aria={aria}
        ariaHideApp={false}
        bodyOpenClassName={bodyOpenClassName}
        className={`${className} w-auto h-auto bg-primaryDefault max-h-screen overflow-y-auto min-w-[300px] mx-1 
        overflow-x-hidden`}
        closeTimeoutMS={closeTimeoutMS}
        contentElement={contentElement}
        contentLabel={contentLabel}
        contentRef={contentRef}
        data={data}
        htmlOpenClassName={htmlOpenClassName}
        id={id}
        onAfterClose={onAfterClose}
        onAfterOpen={onAfterOpen}
        onRequestClose={onRequestClose}
        overlayClassName={`${overlayClassName}
         z-[999999999] bg-primaryLight/60 w-full h-full fixed top-0
          flex justify-center items-center`}
        overlayElement={overlayElement}
        overlayRef={overlayRef}
        parentSelector={parentSelector}
        portalClassName={portalClassName}
        preventScroll={preventScroll}
        role={role}
        shouldCloseOnEsc={shouldCloseOnEsc}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        shouldFocusAfterRender={shouldFocusAfterRender}
        shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
        style={style}
        testId={testId}
      >
        <div className='flex justify-center items-center h-10 border-b border-primaryLight bg-inherit/40 sticky top-0 z-40 backdrop-blur-sm shadow-md'>
          <Icon
            icon='rayteb-android-close'
            className='text-2xl !absolute  !right-2'
            onClick={() => {
              hideModal?.()
            }}
          />
          <span className='text-sm text-primary'>{title}</span>
        </div>
        <div className='pt-5'>{children}</div>
      </Modal>
    </>
  )
}

export default React.memo(RaytebModal)
